import React, { createRef } from 'react'
import { useTranslation } from 'react-i18next'

import Card from 'components/Shared/Card'
import HorizontalBarChart from 'components/Shared/Charts/HorizontalBarChart'
import { ContributionTags as ContributionTagsType } from 'types/ContributionTags'
import CardSkeleton from 'components/Shared/SkeletonStack/Card/CardSkeleton'
import NoDataComp from 'components/Shared/NoData'
import { useAppSelector } from 'redux/Hook'

type ContributionTagsCardProps = {
  contributionTagsData: ContributionTagsType
  isLoading: boolean
}

const ContributionTags = ({
  contributionTagsData,
  isLoading,
}: ContributionTagsCardProps) => {
  const { t } = useTranslation()
  const {
    stakeholderDashboardDetails: { accessToken = '' },
  }: any = useAppSelector((state) => state)

  // create contribution tags ref
  const createMoreVertRef = createRef<HTMLDivElement>()

  const moreVertProps = {
    moreVertOptions: ['jpeg', 'png', 'pdf', 'csv'],
    moreVertRef: createMoreVertRef,
    fileNameKey: 'contributionTags',
  }

  const checkIfDataExists = () => {
    const data = contributionTagsData?.data
    return data?.length > 0
  }

  const getDataComp = () => {
    const ifData = checkIfDataExists()

    if (ifData) {
      return (
        <HorizontalBarChart
          data={contributionTagsData?.data}
          xKey="name"
          yKey="count"
          title={t('reporting.overview.contributionTags')}
          height={300}
        />
      )
    }
    return <NoDataComp />
  }

  const buildSkeleton = (
    <CardSkeleton showHeaderSkeleton={false} sectionCount={1} height={300} />
  )

  const contributionTagsChartContent = () => {
    return isLoading ? buildSkeleton : getDataComp()
  }

  return (
    <Card
      info={contributionTagsData?.info}
      moreVertProps={moreVertProps}
      header={t('reporting.overview.contributionTags')}
      topContentSpacing="none"
      content={contributionTagsChartContent()}
      showMoreAction={checkIfDataExists() && !accessToken}
    />
  )
}

export default ContributionTags
